/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import { isMobile } from 'react-device-detect'

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const openAppURL = (url: string, fallback?: () => void) => {
  if (!isMobile) {
    return
  }

  document.location.href = url
  let time = (new Date()).getTime()
  setTimeout(function(){
    let now = (new Date()).getTime()

    if((now - time)<400) {
      fallback && fallback()
    }
  }, 300);
  setTimeout(fallback, 300)
}

export const getAppURL = (slug: string, path?: string) => {
  return slug + '://' + path
}

export const getUUID = () =>{
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}